import { Component } from '@verndale/core';
import { ExtendedWindowType } from '../helpers/global-types';

class CategorySelectionBar extends Component {
  setupDefaults() {
    this.dom = {
      links: this.el.querySelectorAll('.category-selection-bar__link'),
      dropdown: this.el.querySelector<HTMLSelectElement>('.field__select')
    };
  }

  addListeners() {
    (this.dom.dropdown as HTMLSelectElement).addEventListener(
      'change',
      this.handleDropdownChange.bind(this)
    );

    (this.dom.links as NodeListOf<HTMLAnchorElement>).forEach(link => {
      link.addEventListener('click', this.handleClick.bind(this));
    });
  }

  handleClick(event: Event) {
    const { target } = event;

    const anchor = (target as HTMLElement).classList.contains(
      'category-selection-bar__link'
    )
      ? target
      : (target as HTMLElement).closest('.category-selection-bar__link');

    (anchor as HTMLAnchorElement).classList.add('active');

    (this.dom.links as NodeListOf<HTMLAnchorElement>).forEach(link => {
      if (link !== anchor) {
        link.classList.remove('active');
      }
    });
  }

  handleDropdownChange(event: Event) {
    const { value } = event.target as HTMLSelectElement;
    (this.dom.links as NodeListOf<HTMLAnchorElement>).forEach(link => {
      link.classList.remove('active');

      if (link.href === value) {
        const layer = link.dataset.layer;
        link.classList.add('active');

        if (layer) {
          const global = window as ExtendedWindowType;
          global.dataLayer?.push(JSON.parse(layer));
        }
      }
    });

    window.location.href = value;
  }
}

export default CategorySelectionBar;
